import React from 'react'
import './_box3612.scss'
import { ReactComponent as Pig } from "../../../assets/new-icons/pig.svg";
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';

function Box3612() {
    const navigate = useNavigate()
  return (
    <div className='box3612 boxInfo'>
        <div className="box3612-top">
            <div className="icon">
                <Pig />
            </div>
            <div className="text">
                <p className="text-top">Ricarica 3, 6, 12</p>
                <p className="text-bottom">15, 20, 30 % di sconto</p>
            </div>
        </div>
        <div className="box3612-bottom">
            <p className="box3612-bottom_text">
                Scopri subito come risparmiare ed avere un prezzo vantaggioso.
            </p>
            <p className="box3612-bottom_text bold">
                Riceverai subito un bonus!
            </p>
        </div>
        <div className="box3612-button" onClick={() => navigate('/enrica/promo')}>
            <p className="main">Risparmia subito</p>
            <ArrowForwardIos />
        </div>
    </div>
  )
}

export default Box3612